// only the important ones for now, feel free to add more as needed/wanted
export enum IdentificationDocumentTypesEnum {
    IdCard_HR_eVisitor = 1,
    Passport_HR_eVisitor = 2,
    IdCard_SL_eTurizem = 38,
    Passport_SL_eTurizem = 41,
    IdCard_None = 44,
    Passport_None = 45
}